import { initDetections, mobileCheck, is_chrome, is_explorer, is_explorer_11, is_firefox, is_safari, is_edge, is_opera, xsMax, smMax, mdMax, lgMax, smMin, mdMin, lgMin, xlMin, mobile } from './detections.js';
import { initEventsPLP } from './events-plp.js'
import { initLocationsPLP } from './locations-plp.js';
import { initNav } from './nav.js';
import { initOutboundTracking } from './outbound.js';
import { initFormTracking } from './forms.js';

jQuery(document).ready(function($){
    // browser sniffing
    // window size variables (bootstrap 4)
    initDetections();

    //Events pagination & cateogry select
    initEventsPLP();

    //Real estate & business PLPs
    initLocationsPLP();


    // Main navigation: dropdowns, mobile drawer and keyboard support
    initNav();


    // Outbound, download and contact click tracking -> dataLayer
    initOutboundTracking();


    // Contact Form 7 submissions and failures -> dataLayer
    initFormTracking();


	// Sticky Nav
    // error: navbar is not defined
	// function stickyNav() {
	// 	var scrollPosition = $(window).scrollTop(),
	// 		scrollDistance = 1,
	// 		windowHeight = $(window).height(),
	// 		bodyHeight = $('body').outerHeight(),
	// 		footerHeight = $('footer').outerHeight();

	// 	if (scrollPosition >= scrollDistance) {
	// 		if ((windowHeight + 108) < (bodyHeight + footerHeight)) {
	// 			navbar.addClass('scrolled');
	// 			$('body').addClass('scrolled');
	// 		}
	// 	} else {
	// 		navbar.removeClass('scrolled');
	// 		$('body').removeClass('scrolled');
	// 	}
	// }
	// $(window).scroll(stickyNav);
	// stickyNav();


	// Magnific Popup
    //check if we've included the plugin first
    if (typeof $.fn.magnificPopup == 'function') {
        // Magnific popup videos
    	$(".mfp-video").magnificPopup({
    		type: 'iframe',
    		closeMarkup: '<span class="video-close icon-menu-close mfp-close"></span>',
            iframe: {
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: function(url) {
                            var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                            if ( !m || !m[1] ) return null;
                            return m[1];
                        },
                        src: '//www.youtube.com/embed/%id%?autoplay=1'
                    },
                    vimeo: {
                        index: 'vimeo.com/',
                        id: function(url) {
                            var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
                            if ( !m || !m[5] ) return null;
                            return m[5];
                        },
                        src: '//player.vimeo.com/video/%id%?autoplay=1'
                    }
                }
            },
    		callbacks: {
    			//pause any background videos when the popup opens, resume when it closes
    			open: function () {
    				var videos = $("video");
                    $('body').addClass('mfp-open');

    				videos.each(function () {
    					var video = $(this),
    						videoElem = video.get(0);

    					//don't pause the mfp video
    					if (video.closest(".mfp-wrap").length === 0) {

    						//if video is playing
    						if (!videoElem.paused && !videoElem.ended) {
    							video.attr("data-was-playing", true);
    							videoElem.pause();
    						}
    					}
    				});
    			},
    			//resume any background videos when the popup opens, resume when it closes
    			close: function () {
    				var videos = $("video[data-was-playing=true]");
                    $('body').removeClass('mfp-open');

    				videos.each(function () {
    					var video = $(this),
    						videoElem = video.get(0);

    					//don't resume the mfp video
    					if (video.closest(".mfp-wrap").length === 0) {

    						videoElem.play();
    					}
    				});
    			}
    		}
    	});

		$('.mfp-img').magnificPopup({
            type: 'image',
    		closeMarkup: '<span class="img-close icon-menu-close mfp-close" tabindex="0"></span>',
			//verticalFit: true, // Fits image in area vertically

			callbacks: {
    			open: function () {
                    $('html').addClass('mfp-open');
    			},
    			//resume any background videos when the popup opens, resume when it closes
    			close: function () {
                    $('html').removeClass('mfp-open');
    			}
    		}
        });
    }

	// trigger click on "enter" for mfp-img
    $('body').on('keydown', '.mfp-img, .mfp-close', function (e) {
        if (e.which == 13) {
            $(this).trigger('click');
            return false;
        }
    });


	// Slick Sliders
    $('.slick-slider').each(function () {
        var id = $(this).attr('id');

        if (id == ('hero-slider')) {
            $(this).slick({
                accessibility: true,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: true,
                prevArrow: $('#' + id + '-arrow-prev'),
                nextArrow: $('#' + id + '-arrow-next'),
                dots: true,
                adaptiveHeight:false,
                appendDots:"#line-dots",
                cssEase: 'ease-out',
                slidesToShow: 1,
                infinite: true,
                slidesToScroll: 1,
                speed: 300,
                rows: 0,
            });

            $('.home-slide').addClass('loaded');
            $('.home-slider .paused').removeClass('paused');

        } else if (id == ('dot-nav-slider')) {
            $(this).slick({
                accessibility: true,
                autoplay: false,
                autoplaySpeed: 5000,
                arrows: false,
                prevArrow: $('#' + id + '-arrow-prev'),
                nextArrow: $('#' + id + '-arrow-next'),
                dots: false,
                adaptiveHeight:false,
                cssEase: 'ease-out',
                slidesToShow: 3,
                infinite: false,
                slidesToScroll: 1,
                variableWidth: true,
                speed: 300,
                rows: 0,
                asNavFor:'#info-slider',
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows:true,
                            slidesToShow:1,
                            infinite: true,
                            variableWidth: false,
                        }
                    }
                ]
            });


        } else if (id == ('info-slider')) {
            $(this).slick({
                accessibility: true,
                autoplay: false,
                autoplaySpeed: 5000,
                arrows: false,
                dots: false,
                adaptiveHeight:false,
                cssEase: 'ease-out',
                slidesToShow: 1,
                infinite: true,
                slidesToScroll: 1,
                speed: 300,
                rows: 0,
                asNavFor:'#dot-nav-slider',
            });


        } else if (id == ('event-slider')) {
            // Only play (and therefore download) the current slide's video, and not until the
            // page has finished loading so it doesn't compete with it (the poster shows until then)
            var eventSlider = $(this),
                pageLoaded = document.readyState === 'complete';

            function syncEventSliderVideos() {
                eventSlider.find('video').each(function () {
                    if (pageLoaded && $(this).closest('.slick-current').length) {
                        var playing = this.play();
                        if (playing !== undefined) {
                            playing.catch(function () {}); // autoplay can be blocked (e.g. low power mode)
                        }
                    } else {
                        this.pause();
                    }
                });
            }

            if (!pageLoaded) {
                $(window).on('load', function () {
                    pageLoaded = true;
                    syncEventSliderVideos();
                });
            }

            $(this).on('init afterChange', syncEventSliderVideos);

            $(this).slick({
                accessibility: true,
                autoplay: false,
                autoplaySpeed: 5000,
                arrows: true,
                prevArrow: $('#' + id + '-arrow-prev'),
                nextArrow: $('#' + id + '-arrow-next'),
                dots: false,
                adaptiveHeight:false,
                cssEase: 'ease-out',
                slidesToShow: 1,
                infinite: true,
                slidesToScroll: 1,
                variableWidth: false,
                speed: 300,
                rows: 0,
                focusOnSelect: true
            });


        } else if (id == ('supporters')) {
            $(this).slick({
                accessibility: true,
                autoplay: true,
                arrows: false,
                cssEase: 'ease-out',
                dots: false,
                slidesToShow: 6,
                speed: 250,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
        } else if (id == ('simple-slider')) {
            $(this).slick({
                accessibility: true,
                autoplay: false,
                arrows: true,
                cssEase: 'ease-out',
                dots: true,
                appendDots: $('#' + id + '-dots-container'),
                slidesToShow: 1,
                speed: 250,
                arrows: true,
                prevArrow: $('#' + id + '-arrow-prev'),
                nextArrow: $('#' + id + '-arrow-next'),
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            dots: false
                        }
                    }
                ]
            });
        } else if (id == ('complicated-slider')) {
            var slideCount,
                thumbSlickSettings = {
                accessibility: true,
                autoplay: false,
                dots: false,
                cssEase: 'ease-out',
                dots: false,
                slidesToShow: 5,
                infinite: true,
                slidesToScroll: 1,
                asNavFor: '#firearm-pdp-main-slider',
                arrows: true,
                prevArrow: $('#' + id + '-arrow-prev'),
                nextArrow: $('#' + id + '-arrow-next'),
                focusOnSelect: true,
                speed: 250,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            }

            function checkSlideCount() {
                if(xsMax) {
                    slideCount = 3;
                } else if(smMax && smMin) {
                    slideCount = 4;
                } else {
                    slideCount = 5;
                }

                if($('.slide').length > slideCount) {

                } else {

                }
            }

            checkSlideCount();
            $(window).on('resize', function() {
                checkSlideCount();
            });

            $(this).slick(thumbSlickSettings);
        } else {
            $(this).slick({
                accessibility: true,
                autoplay: false,
                nextArrow: $('#' + id +'-arrow-next'),
                prevArrow: $('#' + id +'-arrow-prev'),
                cssEase: 'ease-out',
                dots: false,
                speed: 250
            });
        }
    });


	// global function for smooth scrolling
    function smoothScroll(target, offset, speed) {
        $('html,body').animate({
            scrollTop: (target.offset().top - offset)
        }, speed);
    }

    // General Smooth Scrolling with no offset (will have to update if the nav is made sticky)
    $('.smooth-scroll').each(function() {
        $(this).on('click', function (e) {
            e.preventDefault();
            var target = $(this).data('target');
			var offset;

			if ($(this).data('offset')) {
			    offset = $(this).data('offset');
			} else {
				if(lgMin) {
					offset = 0;
				} else {
					offset = 0;
				}
			}

			// add hash to URL
            // if (target) {
            //     window.location.hash = target;
            // }

            smoothScroll($(target), offset, 0);
        });
    });


    // Scroll Magic Tweens & Parallax
	// TweenMax timeline functions
    function addFrom(timeline, element, duration, properties, position) {
		timeline.add(TweenMax.from(
			element,
			duration,
			properties
		), position);
	}

    function addTo(timeline, element, duration, properties, position) {
		timeline.add(TweenMax.to(
			element,
			duration,
			properties
		), position);
	}

    function addFromTo(timeline, element, duration, fromProperties, toProperties, position) {
        timeline.add(TweenMax.fromTo(
			element,
			duration,
			fromProperties,
            toProperties
		), position);
    }

    // init controller
    var controller = new ScrollMagic.Controller();

    // standard y parallax images
	$('.parallax-window').each(function(index) {
        var triggerWindow = '#window-' + index,
            standardTween,
            image = triggerWindow + ' .parallax-image',
            scene;

        $(this).attr('id', triggerWindow.slice(1));

		if(!mobileCheck()) {
			// build tween
	        standardTween = TweenMax.to(triggerWindow + ' .parallax-image', 1, {y: '80%', ease: Linear.easeNone});

	        // build scene
	        scene = new ScrollMagic.Scene({
	            triggerElement: triggerWindow,
	            triggerHook: 'onEnter',
	            duration: '200%'
	        })
	        .setTween(standardTween)
	        .addTo(controller);

	        // tell image that parallax function ran
	        $(image).addClass('parallax-js-loaded');
		} else {
			$(image).css('transform','none');
		}
    });

    // Parallax Accents
    function initParallaxAccent() {
        $('.parallax_accent').each(function(index, elem){
            var triggerWindow = $(this).parent('.parallax_group'),
                parallaxTween,
                scene,
                ramp,
                ease,
                duration,
				rotation,
				scale,
                hook,
				windowHeight = $(window).innerHeight();

			// set variables / defaults
			duration = $(this).data('duration');
            if(duration == undefined) {
                duration = '200%';
            }
            ramp = $(this).data('ramp');
            if(ramp == undefined) {
                ramp = '80%';
            }
			hook = $(this).data('hook');
            if(hook == undefined) {
                hook = 1.0;
            }
			ease = $(this).data('ease');
            if(ease == undefined) {
                ease = 'power4.out';
            }
			rotation = $(this).data('rotation');
			if(rotation == undefined) {
                rotation = 0;
            }
			horizontal = $(this).data('horizontal');
			if(horizontal == undefined) {
                horizontal = 0;
            }
			scale = $(this).data('scale');
			if(lgMin) {
				if(scale == undefined) {
					scale = 1.0;
				}
			} else {
				if(scale == undefined) {
					scale = 0.7;
				} else {
					//scale = .7 * scale;
					scale = 0.7;
				}
			}

			$(elem).css({
				'transform': 'scale(' + scale + ') translateX(' + horizontal + ')',
				'opacity': '1'
			});

            //if(notMobile) {
    			// build tween
    	        parallaxTween = TweenMax.to(elem, 1, {y: ramp, ease: ease, rotation: rotation, scale: scale});

    	        // build scene
    	        scene = new ScrollMagic.Scene({
    	            triggerElement: $(triggerWindow).get(0),
    	            triggerHook: hook,
    	            duration: duration
    	        })
    	        .setTween(parallaxTween)
                //.addIndicators() // add indicators
    	        .addTo(controller);

    	        // tell accent that the parallax function ran
    	        $(elem).addClass('parallax-js-loaded');
    		//}
        });
    }
    initParallaxAccent();

    // Once triggered, slide elem1 and elem2 up, then fade in elem2 after a delay
    function initSlideFade() {
        $('.slide_fade').each(function(index, elem){
            var timeline,
                scene,
                hook,
                elem1,
                elem2,
                slideDistance,
                fadeDelay,
                slideSpeed,
                trigger,
                initialDelay,
                fadeSpeed;

            // create timeline
            timeline = new TimelineMax();

            // grab both elements
            elem1 = $(this).find('.elem1');
            elem2 = $(this).find('.elem2');

            // set variables / defaults
            initialDelay = $(this).data('initial-delay');
            if(initialDelay == undefined) {
                initialDelay = 0;
            }

            slideSpeed = $(this).data('slide-speed');
            if(slideSpeed == undefined) {
                slideSpeed = 0.25;
            }

            fadeSpeed = $(this).data('fade-speed');
            if(fadeSpeed == undefined) {
                fadeSpeed = 0.5;
            }

            slideDistance = $(this).data('slide-distance');
            if(slideDistance == undefined) {
                slideDistance = '30px';
            }

            fadeDelay = $(this).data('fade-delay');
            if(fadeDelay == undefined) {
                fadeDelay = .5;
            }

            // determine if should run timeline on load or when scrolled into view
            if($(this).hasClass('onload')) {
                trigger = $('#top');
                hook = 0;
            } else {
                trigger = elem;
                hook = $(this).data('hook');

                if(hook == undefined) {
                    hook = 0.6;
                }
            }

            // slide elem1 up
            addFromTo(timeline, elem1, slideSpeed, {
                ease: Linear.easeIn,
                opacity: 0,
                y: slideDistance
            }, {
                opacity: 1,
                y: "0"
            }, "+=" + initialDelay);

            // slide elem2 up at the same time as elem1
            addFromTo(timeline, elem2, slideSpeed, {
                ease: Linear.easeIn,
                y: slideDistance
            }, {
                y: "0"
            }, "-=" + slideSpeed);

            // fade elem2 in after a delay
            addFromTo(timeline, elem2, slideSpeed, {
                ease: Linear.easeIn,
                opacity: 0
            }, {
                opacity: 1

            }, "+=" + fadeDelay);

            // build scene
            scene = new ScrollMagic.Scene({
                triggerElement: trigger,
                triggerHook: hook,
                reverse: false
            })
            .setTween(timeline)
            //.addIndicators() // add indicators
            .addTo(controller);
        });
    }
    initSlideFade();


	// Fade in
	function initFadeIn() {
        $('.fade_in').each(function(index, elem){
            var tweenFade,
                scene,
                distance,
                hook,
                speed;

            // set variables / defaults
            speed = $(this).data('speed');
            if(speed == undefined) {
                speed = 0.3;
            }
            hook = $(this).data('hook');
            if(hook == undefined) {
                hook = 0.8;
            }

            // build tween
            tweenFade = TweenMax.fromTo(elem, speed, {opacity: 0}, {opacity: 1, ease: Linear.easeIn});

            // build scene
            scene = new ScrollMagic.Scene({
                triggerElement: elem,
                triggerHook: hook,
                reverse: true
            })
            .setTween(tweenFade)
            //.addIndicators() // add indicators
            .addTo(controller);
        });
    }
    initFadeIn();

	function initSlideUp() {
        $('.slide_up').each(function(index, elem){
            var tweenSlideUp,
                scene,
                distance,
                hook,
                speed;

            // set variables / defaults
            distance = $(this).data('distance');
            if(distance == undefined) {
                distance = '30px';
            }
            speed = $(this).data('speed');
            if(speed == undefined) {
                speed = 0.3;
            }
			hook = $(this).data('hook');
            if(hook == undefined) {
                hook = 0.8;
            }

            // build tween
            tweenSlideUp = TweenMax.fromTo(elem, speed, {opacity: 0, y: distance}, {opacity: 1, y: '0', ease: Linear.easeIn});

            // build scene
            scene = new ScrollMagic.Scene({
                triggerElement: elem,
                triggerHook: hook,
                reverse: false
            })
            .setTween(tweenSlideUp)
            .addIndicators() // add indicators
            .addTo(controller);
        });
    }
    initSlideUp();

	function initSlideDown() {
        $('.slide_down').each(function(index, elem){
            var tweenSlideDown,
                scene,
                distance,
                hook,
                speed;

            // set variables / defaults
            distance = $(this).data('distance');
            if(distance == undefined) {
                distance = '30px';
            }
            speed = $(this).data('speed');
            if(speed == undefined) {
                speed = 0.3;
            }
			hook = $(this).data('hook');
            if(hook == undefined) {
                hook = 0.8;
            }

            // build tween
            tweenSlideDown = TweenMax.fromTo(elem, speed, {opacity: 0, y: '-' + distance}, {opacity: 1, y: '0', ease: Linear.easeIn});

            // build scene
            scene = new ScrollMagic.Scene({
                triggerElement: elem,
                triggerHook: hook,
                reverse: false
            })
            .setTween(tweenSlideDown)
            //.addIndicators() // add indicators
            .addTo(controller);
        });
    }
    initSlideDown();

	function initScrollSlideDown() {
        $('.scroll_slide_down').each(function(index, elem){
            var tweenSlideDown,
                scene,
                distance,
                hook,
                speed;

            // set variables / defaults
            distance = $(this).data('distance');
            if(distance == undefined) {
                distance = '50px';
            }
            speed = $(this).data('speed');
            if(speed == undefined) {
                speed = 0.3;
            }

            // build tween
            tweenSlideDown = TweenMax.fromTo(elem, speed, {opacity: 0, y: '-' + distance}, {opacity: 1, y: '0', ease: Linear.easeIn});

            // build scene
            scene = new ScrollMagic.Scene({
                triggerElement: '',
                triggerHook: '',
				offset: 1.0,
                reverse: false
            })
            .setTween(tweenSlideDown)
            //.addIndicators() // add indicators
            .addTo(controller);
        });
    }
    initScrollSlideDown();

	function initLoadSlideDown() {
        $('.load_slide_down').each(function(index, elem){
            var tweenSlideDown,
                scene,
                distance,
                hook,
                speed;

            // set variables / defaults
            distance = $(this).data('distance');
            if(distance == undefined) {
                distance = '50px';
            }
            speed = $(this).data('speed');
            if(speed == undefined) {
                speed = 0.3;
            }

            // build tween
            tweenSlideDown = TweenMax.fromTo(elem, speed, {opacity: 0, y: '-' + distance}, {opacity: 1, y: '0', ease: Linear.easeIn});

            // build scene
            scene = new ScrollMagic.Scene({
                triggerElement: $('#top'),
                triggerHook: 0.0,
                reverse: false
            })
            .setTween(tweenSlideDown)
            //.addIndicators() // add indicators
            .addTo(controller);
        });
    }
    initLoadSlideDown();

	function initSlideFromLeft() {
        $('.slide_from_left').each(function(index, elem){
            var tweenSlideFromLeft,
                scene,
                distance,
                ease,
                delay,
                hook,
                speed;

            // set variables / defaults
            distance = $(this).data('distance');
            if(distance == undefined) {
                distance = '30px';
            }
            speed = $(this).data('speed');
            if(speed == undefined) {
                speed = 0.3;
            }
			hook = $(this).data('hook');
            if(hook == undefined) {
                hook = 0.8;
            }
			ease = $(this).data('ease');
            if(ease == undefined) {
                ease = 'Linear.easeIn';
            }
			delay = $(this).data('delay');
            if(delay == undefined) {
                delay = 0;
            }

            // build tween
            tweenSlideFromLeft = TweenMax.fromTo(elem, speed, {opacity: 0, x: '-' + distance}, {opacity: 1, x: '0', ease: ease, delay: delay});

            // build scene
            scene = new ScrollMagic.Scene({
                triggerElement: elem,
                triggerHook: hook,
                reverse: false
            })
            .setTween(tweenSlideFromLeft)
            //.addIndicators() // add indicators
            .addTo(controller);
        });
    }
    initSlideFromLeft();

	function initSlideFromRight() {
        $('.slide_from_right').each(function(index, elem){
            var tweenSlideFromRight,
                scene,
                distance,
                ease,
                delay,
                hook,
                speed;

            // set variables / defaults
            distance = $(this).data('distance');
            if(distance == undefined) {
                distance = '30px';
            }
            speed = $(this).data('speed');
            if(speed == undefined) {
                speed = 0.3;
            }
			hook = $(this).data('hook');
            if(hook == undefined) {
                hook = 0.8;
            }
            ease = $(this).data('ease');
            if(ease == undefined) {
                ease = 'Linear.easeIn';
            }
            delay = $(this).data('delay');
            if(delay == undefined) {
                delay = 0;
            }

            // build tween
            tweenSlideFromRight = TweenMax.fromTo(elem, speed, {opacity: 0, x: distance}, {opacity: 1, x: '0', ease: ease, delay: delay});

            // build scene
            scene = new ScrollMagic.Scene({
                triggerElement: elem,
                triggerHook: hook,
                reverse: false
            })
            .setTween(tweenSlideFromRight)
            //.addIndicators() // add indicators
            .addTo(controller);
        });
    }
    initSlideFromRight();

	// Play video on scroll
	function playOnScroll() {
		var screenTop = $(window).scrollTop(),
			screenBottom = $(window).scrollTop() + $(window).innerHeight();

		$('.scroll_play').each(function(){
			var video = $(this),
				played = video.data('played'),
				videoTop = $(video).offset().top,
				videoBottom = $(video).offset().top + $(video).outerHeight();

			// Play when video enters viewport and pause when it completely leaves viewport
			if ((screenBottom > videoTop) && (screenTop < videoBottom)) {
				$(video).get(0).play();
				video.data('played',true);
		    } else {
				$(video).get(0).pause();
			}
		});
	}
    playOnScroll();
	$(window).scroll(playOnScroll);

	// Play video on scroll
	function playRender() {
		var windowHeight = $(window).innerHeight(),
			screenTop = $(window).scrollTop(),
			screenBottom = screenTop + windowHeight,
			screenMid = (screenTop) + (windowHeight / 2);

		$('.product-render').each(function(){
			var video = $(this),
				wrapper = $(this).parents('.product-img-wrapper'),
				played = video.data('played'),
				wrapperTop = $(wrapper).offset().top,
				wrapperBottom = $(wrapper).offset().top + $(wrapper).outerHeight(),
				wrapperMid = (wrapperTop + wrapperBottom) / 2,
				playTrigger = screenMid;

				if(video.data('trigger')) {
					playTrigger = (screenTop) + (windowHeight * video.data('trigger'));
				}

			// Play when video wrapper is in the middle of the viewport (plays once)
			if(!video.data('played')) {
				if (playTrigger > wrapperMid) {
					$(video).get(0).play();
					video.data('played',true);
                    video.css('opacity','1.0');
			    }
			}
		});
	}
	$(window).scroll(playRender);



    $(window).on('resize', function(){
        compare();
    });

    compare();

    function compare(){
        if(!mobileCheck()){
            $('.image-compare-inner').addClass('compare');
            $('.image-compare-inner').removeClass('mobile');
            $('.image-compare-inner.compare').each(function(){
                var actual = $(this);
                drags(actual.find('.handle'), actual.find('.img-comp-overlay'), actual);
            });
        }else{
            $('.image-compare-inner').addClass('mobile');
            $('.image-compare-inner').removeClass('compare');
            $('.image-compare-inner.compare').find('.handle').removeClass('draggable');
            $('.image-compare-inner.compare').find('.handle').off('mousedown vmousedown');
            $('.image-compare-inner.compare').parents().off("mousemove vmousemove touchmove");
        }
    }


    //draggable funtionality
    function drags(dragElement, resizeElement, container) {
       dragElement.on("mousedown vmousedown", function(e) {
          dragElement.addClass('draggable');
          resizeElement.addClass('resizable');

          var dragWidth = dragElement.outerWidth(),
              xPosition = dragElement.offset().left + dragWidth - e.pageX,
              containerOffset = container.offset().left,
              containerWidth = container.outerWidth(),
              minLeft = containerOffset + 10,
              maxLeft = containerOffset + containerWidth - dragWidth - 10;

          dragElement.parents().on("mousemove vmousemove touchmove", function(e) {
             var leftValue = e.pageX + xPosition - dragWidth;

             //constrain the draggable element to move inside its container
             if(leftValue < minLeft ) {
                leftValue = minLeft;
             } else if ( leftValue > maxLeft) {
                leftValue = maxLeft;
             }

             var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';

             $('.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
                $(this).removeClass('draggable');
                resizeElement.removeClass('resizable');
             });

             $('.resizable').css('width', widthValue);

             //function to upadate images label visibility here
             // ...

          }).on("mouseup vmouseup", function(e){
             dragElement.removeClass('draggable');
             resizeElement.removeClass('resizable');
          });
          //e.preventDefault();
       }).on("mouseup vmouseup", function(e) {
          dragElement.removeClass('draggable');
          resizeElement.removeClass('resizable');
       });}

});
